module.exports = __webpack_public_path__ + "img/qrcode.e3018cef.png";